import React, { useEffect, useState } from "react";
import {
  IconButton,
  Popper,
  Paper,
  Typography,
  Button,
  Box,
  Stack,
  Fade,
  Chip,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Icon } from "@iconify/react";
import SiAutocomplete from "../../core/si-autocomplete";
import SiTextField from "../../core/si-textfield";
import { convertCamelCaseToDisplayText } from "../../utils";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { TICKET_STAGES } from "../../pages/admin/ticket-details-v2/helper";
import { USER_LIMITS } from "../../utils/constants";
import { toast } from "react-toastify";

const CustomDashboardFilters = ({
  filters,
  onApplyFilters,
  updateOrgList,
  setDefectCodeList,
  setComplaintCodes,
  setServiceEngineers,
  setTicketStages,
  setEngineModel,
  setListNumbers,
  isSplitFilter = false,
  selectedFilters,
  setSelectedFilters,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const open = Boolean(anchorEl);
  const id = open ? "filter-popper" : undefined;
  const [endDate, setEndDate] = useState("");

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleAddFilter = () => {
    if (filterType && filterValue) {
      let val = filterValue;
      if (filterType === "date") {
        if (!endDate) {
          toast.error("End Date is required");
          return;
        }
        val = `${filterValue} to ${endDate}`;
      }
      const newFilter = { type: filterType, value: val };
      setSelectedFilters((prev) => [...prev, newFilter]);
      setFilterType("");
      setFilterValue("");
    }
  };

  const handleRemoveFilter = (type) => {
    const updatedFilters = selectedFilters.filter(
      (filter) => filter.type !== type
    );
    setSelectedFilters(updatedFilters);
    const filtersObj = updatedFilters.reduce((acc, filter) => {
      acc[filter.type] = filter.value;
      return acc;
    }, {});
    if (isSplitFilter) {
      onApplyFilters(filtersObj, isSplitFilter);
    } else {
      onApplyFilters(filtersObj);
    }
  };
  const loadServiceEngineers = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_ENGINEER}`,
      null,
      {
        role: USER_LIMITS.SERVICE_ENGINEER,
        page: 1,
        limit: 1000,
      }
    )
      .then((response) => {
        if (response.results) {
          const result = response?.results?.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setServiceEngineers(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadEngineModel = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.ENGINE_MODEL_LIST}`)
      .then((response) => {
        if (!response.message) {
          const result = response?.map((ele) => ({
            label: ele,
            value: ele,
          }));

          setEngineModel(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadListNumber = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.LIST_NUMBERS_LIST}`)
      .then((response) => {
        if (!response.message) {
          const result = response?.map((ele) => ({
            label: ele,
            value: ele,
          }));
          setListNumbers(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleApply = () => {
    const filters =
      selectedFilters.length > 0
        ? selectedFilters
        : filterType && filterValue
        ? [{ type: filterType, value: filterValue }]
        : [];
    if (selectedFilters.length < 1 && filterType && filterValue) {
      handleAddFilter();
    }
    if (filters.length > 0) {
      const filtersObj = filters.reduce((acc, filter) => {
        acc[filter.type] = filter.value;
        return acc;
      }, {});
      if (isSplitFilter) {
        onApplyFilters(filtersObj, isSplitFilter);
      } else {
        onApplyFilters(filtersObj);
      }
      setAnchorEl(null);
    }
  };
  const onClearSelectedFilters = () => {
    // setSelectedFilters([]);
    setFilterType("");
    setFilterValue("");
    setAnchorEl(null);
    // onApplyFilters({});
  };
  const loadOemOrg = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`)
      .then((res) => {
        if (!res.message) {
          const result = res.map((ele) => ({ label: ele.name, value: ele.id }));
          updateOrgList(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: ele.id,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadComplaintCodes = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: r.id,
            };
          });
          setComplaintCodes(codes);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (filterType === "oemOrg") {
      loadOemOrg();
    }
    if (filterType === "defectCode") {
      loadDefectCodes();
    }
    if (filterType === "complaintCode") {
      loadComplaintCodes();
    }
    if (filterType === "serviceEngineer") {
      loadServiceEngineers();
    }
    if (filterType === "engineModal") {
      loadEngineModel();
    }
    if (filterType === "listNumber") {
      loadListNumber();
    }
    if (filterType === "stage") {
      const arr = [];
      for (let ele in TICKET_STAGES) {
        arr.push({ label: TICKET_STAGES[ele], value: ele });
      }
      setTicketStages(arr);
    }
  }, [filterType]);
  return (
    <div>
      <IconButton onClick={handleClick} aria-describedby={id}>
        <FilterListIcon />
      </IconButton>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        transition
        sx={{ zIndex: 1200 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={{ padding: "10px", maxWidth: 400, minWidth: 300 }}>
              <Typography variant="h6" gutterBottom>
                Filters
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  mb: 2,
                  gridGap: "5px",
                }}
              >
                {selectedFilters?.map((filter, index) => (
                  <div
                    key={index}
                    className={`chip-com-con ${
                      (index + 1) % 2 ? "purple-bg" : "orange-bg"
                    }`}
                  >
                    <p>
                      {`${convertCamelCaseToDisplayText(filter.type)}: ${
                        typeof filter.value === "object"
                          ? filter?.value?.label
                          : filter.value
                      }`}
                    </p>
                    <CloseOutlinedIcon
                      onClick={() => {
                        handleRemoveFilter(filter.type);
                      }}
                      fontSize="small"
                      sx={{ ml: 1, cursor: "pointer" }}
                    />
                  </div>
                ))}
              </Box>

              {/* Filter Type Dropdown */}
              <SiAutocomplete
                placeholder="Select Filter Type"
                value={filters.find((f) => f.name === filterType)}
                onChange={(val) => setFilterType(val?.name || "")}
                options={filters
                  .filter(
                    (filter) =>
                      !selectedFilters.some((f) => f.type === filter.name)
                  )
                  .map((filter) => ({
                    label: filter.label,
                    name: filter.name,
                  }))}
              />

              {/* Dynamic Input Field for Filter Value */}
              {filterType && (
                <Box sx={{ mt: 2 }}>
                  {filters.find((f) => f.name === filterType)?.type ===
                  "autocomplete" ? (
                    <SiAutocomplete
                      placeholder={`Select ${filterType}`}
                      value={filterValue}
                      onChange={(val) => setFilterValue(val)}
                      options={
                        filters.find((f) => f.name === filterType)?.options ||
                        []
                      }
                    />
                  ) : filters.find((f) => f.name === filterType)?.type ===
                    "dateRange" ? (
                    <Box sx={{ display: "flex", gap: "20px" }}>
                      <div>
                        <p style={{ margin: "0px", fontWeight: 500 }}>
                          Start Date
                        </p>
                        <SiTextField
                          placeholder="Start Date"
                          name="date"
                          type="date"
                          onChange={(e) => setFilterValue(e.target.value)}
                          sx={{ mt: 1 }}
                        />
                      </div>
                      <div>
                        <p style={{ margin: "0px", fontWeight: 500 }}>
                          End Date
                        </p>
                        <SiTextField
                          placeholder="End Date"
                          name="endDate"
                          type="date"
                          onChange={(e) => setEndDate(e.target.value)}
                          sx={{ mt: 1 }}
                        />
                      </div>
                    </Box>
                  ) : (
                    <SiTextField
                      placeholder={`Enter ${filterType}`}
                      value={filterValue}
                      onChange={(e) => setFilterValue(e.target.value)}
                    />
                  )}
                </Box>
              )}

              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 2 }}
                fullWidth
                disabled={!filterType || !filterValue}
                onClick={handleAddFilter}
              >
                Add Filter
              </Button>

              <div className="ticket-filter-buttons" style={{ marginTop: 16 }}>
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  onClick={onClearSelectedFilters}
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApply}
                  startIcon={
                    <Icon
                      icon="tabler:filter-search"
                      width="1.2rem"
                      height="1.2rem"
                      style={{ color: "white" }}
                    />
                  }
                >
                  Apply
                </Button>
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export default CustomDashboardFilters;
